import styles from "./style.module.scss";
import classNames from "classnames";
import { useState } from "react";
import VLButton from "../../../uikit/Buttons/VLButton";

interface InviteInputProps {
  inputStr: string;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmitInvite: () => Promise<void>;
  inviteBtnDisabled: boolean;
  inputDisabled: boolean;
}

export const InviteInput = ({
  inputStr,
  onInputChange,
  onSubmitInvite,
  inviteBtnDisabled,
  inputDisabled,
}: InviteInputProps) => {
  const [inviteInProgress, setInviteInProgress] = useState<boolean>(false);

  const handleSendInvitation = async () => {
    setInviteInProgress(true);
    await onSubmitInvite();
    setInviteInProgress(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSendInvitation();
    }
  };

  const handleSendInvitationClick = () => {
    if (!inviteBtnDisabled) {
      handleSendInvitation();
    }
  };

  return (
    <div className={styles.sharingMenuInvite}>
      <input
        type="text"
        placeholder="Invite others by email"
        className={classNames(styles.sharingMenuInput, {
          [styles.sharingMenuInputDisabled]: inputDisabled,
        })}
        onChange={onInputChange}
        onKeyDown={handleKeyDown}
        value={inputStr}
        disabled={inviteInProgress}
        data-testid="invite-input"
      />

      <VLButton
        className={styles.sharingMenuInviteButton}
        type="primary"
        disabled={inviteBtnDisabled}
        onClick={handleSendInvitationClick}
        data-testid="invite-button"
        loading={inviteInProgress}
      >
        SEND
      </VLButton>
    </div>
  );
};
